import { LOAD_CART_REQUEST } from 'dux/checkoutCart/actionTypes';

import {
  CREATE_GIFT_ERROR,
  CREATE_GIFT_REQUEST,
  CREATE_GIFT_SUCCESS,
  SET_SELECTED_GIFT,
} from './actionTypes';

const initialState = {
  isLoading: false,
  isSaving: false,
  error: null,
  selectedGift: null,
  giftPubkey: null,
};

export default function feedbackReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_GIFT:
      return { ...state, selectedGift: action.selectedGift };
    case CREATE_GIFT_REQUEST:
      return { ...state, isSaving: true };
    case CREATE_GIFT_SUCCESS:
      return { ...state, giftPubkey: action.giftPubkey, isSaving: false, error: null };
    case CREATE_GIFT_ERROR:
      return { ...state, error: action.error, isSaving: false };
    case LOAD_CART_REQUEST:
      return initialState;
    default:
      return state;
  }
}
